module.exports = __webpack_public_path__ + "media/icons/pencil-edit-3deac487.png";